import React from "react";
import styled, { keyframes, ThemeProvider } from "styled-components";
import { DarkTheme } from "./Themes";

import LogoComponent from "../subComponents/LogoComponent";
import SocialIcons from "../subComponents/SocialIcons";
import PowerButton from "../subComponents/PowerButton";
import ParticleComponent from "../subComponents/ParticleComponent";

import astronaut from '../assets/Images/profile-img.png';
import BigTitle from "../subComponents/BigTitle"

const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  padding-top: 1rem; /* Moves content slightly upwards */

  @media (max-width: 768px) {
    height: auto;
    min-height: 100vh;
    padding-top: 6rem; /* Adjusted for smaller screens */
    padding-bottom: 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
  }
`;

const float = keyframes`
  0% { transform: translateY(-10px); }
  50% { transform: translateY(15px) translateX(15px); }
  100% { transform: translateY(-10px); }
`;

const Spaceman = styled.div`
  position: absolute;
  top: 8%; /* Moves Spaceman slightly upwards */
  right: 5%;
  width: 20vw;
  animation: ${float} 4s ease infinite;
  z-index: 2;

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 1200px) {
    width: 25vw;
  }

  @media (max-width: 768px) {
    width: 30vw;
    top: 3%; /* Adjusted for smaller screens */
    right: 2%;
  }

  @media (max-width: 480px) {
    width: 40vw;
    top: 2%;
    right: 1%;
  }
`;

const Main = styled.div`
  border: 2px solid ${(props) => props.theme.text};
  color: ${(props) => props.theme.text};
  padding: 2rem;
  width: 50vw;
  height: auto;
  min-height: 70vh;
  z-index: 3;
  line-height: 1.5;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: calc(0.6rem + 1vw);
  backdrop-filter: blur(4px);

  position: absolute;
  left: calc(5rem + 5vw + 3rem); /* Increased left margin to avoid overlap with social icons */
  top: 8rem;

  font-family: 'Ubuntu Mono', monospace;
  font-style: italic;

  overflow-y: auto;
  max-height: 75vh;

  @media (max-width: 1200px) {
    width: 50vw; /* Reduced width */
    left: calc(4rem + 4vw + 3.5rem); /* Increased left margin */
    padding: 1.8rem;
    top: 10rem;
    min-height: 65vh;
  }

  @media (max-width: 768px) {
    position: relative;
    width: 70vw; /* Further reduced width */
    min-height: 55vh;
    max-height: none;
    left: 0;
    top: 1rem;
    margin: 7rem auto 2rem;
    margin-left: 5rem; /* Explicit left margin to avoid social icons */
    margin-right: auto;
    text-align: center;
    padding: 1.5rem;
    font-size: calc(0.7rem + 1vw);
  }

  @media (max-width: 576px) {
    width: 75vw;
    min-height: 50vh;
    padding: 1.2rem;
    margin-top: 8rem;
    margin-bottom: 3rem;
    margin-left: 4.5rem; /* Adjusted for this breakpoint */
    font-size: calc(0.65rem + 1vw);
  }

  @media (max-width: 480px) {
    width: 80vw;
    padding: 1rem;
    margin-top: 6rem;
    min-height: 45vh;
    margin-left: 4rem; /* Adjusted for this breakpoint */
    font-size: calc(0.6rem + 1vw);
    line-height: 1.4;
  }

  @media (max-width: 320px) {
    width: 85vw;
    padding: 0.8rem;
    font-size: calc(0.55rem + 1vw);
    margin-top: 5rem;
    margin-left: 3.5rem; /* Adjusted for this breakpoint */
    min-height: 40vh;
    line-height: 1.3;
  }
`;

const SocialIconsWrapper = styled.div`
  position: relative;
  z-index: 5;
`;

const BigTitleWrapper = styled.div`
  @media (max-width: 768px) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`;

const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  
  @media (max-width: 768px) {
    justify-content: flex-end;
    padding-right: 5%;
  }
`;

const AboutPage = () => {
  return (
    <ThemeProvider theme={DarkTheme}>
      <Box>
        <LogoComponent theme="dark" />
        <PowerButton />
        <ParticleComponent theme="dark" />

        <SocialIconsWrapper>
          <SocialIcons theme="dark" />
        </SocialIconsWrapper>

        <Spaceman>
          <img src={astronaut} alt="spaceman" />
        </Spaceman>

        <ContentContainer>
          <Main>
            I'm a passionate Full Stack Web Developer with hands-on experience in building dynamic, responsive web applications from front to back. I thrive on solving real-world problems through clean, efficient code and love diving deep into the world of Machine Learning to create intelligent solutions. A dedicated problem solver at heart, I constantly seek opportunities to grow as a continuous learner, embracing new technologies and challenges every day.
            <br /><br />
            I believe everything is an art when you put your consciousness into it. You can connect with me via social links.


          </Main>
        </ContentContainer>

        <BigTitleWrapper>
          <BigTitle text='ABOUT' top="20%" left="5%" />
        </BigTitleWrapper>
      </Box>
    </ThemeProvider>
  );
};

export default AboutPage;
